import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HomeMain from './components/Home/HomeMain';
import PrivacyPolicy from './components/PrivacyPolicy';
import Disclaimer from './components/Disclaimer';
import ComingSoon from "./components/ComingSoon"
import Form from "./components/Form"


const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <ComingSoon />
      // element: <Form />
      // element:<HomeMain/>,  
    },
    {
      path: "/product",
      element: <HomeMain />
    },
    {
      path: "/PrivacyPolicy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/Disclaimer",
      element: <Disclaimer />,
    }
  ])
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  )
}

export default App